// src/services/wpApi.ts
import axios from "axios";

export const wpApi = axios.create({
  baseURL: "https://mdapi.manikarndigital.com/wp-json",
  headers: {
    "Content-Type": "application/json",
  },
});

// helper: fetch posts (returns data + headers)
export async function getPosts(page = 1, perPage = 10) {
  const res = await wpApi.get("/wp/v2/posts", { params: { _embed: true, page, per_page: perPage }});
  return {
    posts: res.data,
    total: Number(res.headers["x-wp-total"] || 0),
    totalPages: Number(res.headers["x-wp-totalpages"] || 0),
  };
}

export async function getPostBySlug(slug: string) {
  const res = await wpApi.get("/wp/v2/posts", { params: { slug, _embed: true }});
  return (res.data && res.data[0]) || null;
}

export async function getCategories() {
  const res = await wpApi.get("/wp/v2/categories", { params: { per_page: 100 }});
  return res.data;
}
